import React, {Component} from 'react';

import PageContainer from './PageContainer';


class Pagination extends Component {
  constructor(props){
    super(props);
    this.state = {
      beginIndex:1, 
      count:0,
      totalCount: 0,
      pageElements: [],
      needPrev: false,
      needNext: false
    };
  }
  componentDidMount(){
    this.setState({
      beginIndex: this.props.beginIndex,
      count: this.props.count,
      totalCount: this.props.totalCount
    }, () => {
      this.calcPageElement();
    });
  }


  componentWillReceiveProps(nextProps){
    if(this.props.beginIndex !== nextProps.beginIndex 
      || this.props.count !== nextProps.count
      || this.props.totalCount !== nextProps.totalCount){
      this.setState({
        beginIndex: nextProps.beginIndex,
        count: nextProps.count,
        totalCount: nextProps.totalCount
      }, () => {
        this.calcPageElement();
      });
    }
  }

  handlePrev(){
    const lastIndex = parseInt(this.state.pageElements[0].num, 10);
    this.props.handlePageChange(lastIndex-1);
  }
  handleNext(){
    const lastIndex = parseInt(this.state.pageElements[9].num, 10);
    this.props.handlePageChange(lastIndex + 1);
  }

  calcPageElement(){
    const {itemsCountPerPage,pageRangeDisplayed} = this.props;
    const {totalCount, beginIndex} = this.state;
    let pageBegin = beginIndex;
    const PAGE_COUNT = itemsCountPerPage;
    const NAV_SIZE = pageRangeDisplayed;


    // 현재 페이지를 결정한다.
    let newPageNum;
    if(PAGE_COUNT === 1){
      newPageNum = parseInt(pageBegin / PAGE_COUNT, 10);
    } else {
      newPageNum = parseInt(pageBegin / PAGE_COUNT, 10) + 1;
    }
    
    let pageScale = newPageNum % NAV_SIZE;  // 몇번째 pageChunk인지.
    if(pageScale !== 0){
      pageScale = parseInt(newPageNum / NAV_SIZE, 10) + 1;  
    } else {
      pageScale = parseInt(newPageNum / NAV_SIZE, 10);
    }

    //console.log(newPageNum, pageScale, pageBegin, totalCount, PAGE_COUNT, NAV_SIZE);

    let newPageStart, newPageEnd;

    /** <참고>
     * pageChunk는 한 NAV_SIZE에 들어가는 페이지 네비게이션 덩어리를 의미. 
     * (예: NAV_SIZE가 10이라면, pageChunk는 1~10, 11~20, 21~30.. 순으로 만들어진다)
     * 그러므로 totalCount가 고정되어 있다면, 
     * 한 pageChunk에 들어가는 페이지 수는 (NAV_SIZE * PAGE_COUNT)을 최대값으로 갖는다.
     * 
     * 그러나 totalCount는 WS에서 pageBegin이 달라질 때마다 PAGE_COUNT만큼 추가로 검색한 결과를 반영하므로
     * pageChunk에 들어가는 페이지 수 (NAV_SIZE * PAGE_COUNT)보다 커질 수 있다.
     * 
     * 이 상황에 따라 첫번째 페이지에서의 pagePerChunk의 최대값은 (NAV_SIZE * PAGE_COUNT)이고,
     * 마지막 페이지에서의 pagePerChunk의 최대값은 2 * (NAV_SIZE * PAGE_COUNT)이다.
     */
    // 한 pageChunk에 '실제 보여줘야 할 페이지'수.
    let pagePerChunk = totalCount - ((pageScale-1) * (NAV_SIZE * PAGE_COUNT));
    if(pagePerChunk >= (NAV_SIZE * PAGE_COUNT)){
      // 다음 pageChunk가 존재한다.
      newPageEnd = NAV_SIZE * pageScale;
      newPageStart = newPageEnd - NAV_SIZE + 1;
    } else if (pagePerChunk === (NAV_SIZE * PAGE_COUNT)){
      // 이번 pageChunk가 마지막.
      newPageEnd = NAV_SIZE * pageScale;
      newPageStart = newPageEnd - NAV_SIZE + 1;
    } else {
      // 이번 pageChunk가 마지막.
        if(pagePerChunk % PAGE_COUNT === 0){
        // 실제 보여주는 페이지수와 PAGE_COUNT가 배수 관계로 딱 맞을 때.
        newPageEnd = ((pageScale - 1) * NAV_SIZE) + parseInt(pagePerChunk/PAGE_COUNT, 10);
        newPageStart = ((pageScale - 1) * NAV_SIZE) + 1;
      } else {
        newPageEnd = ((pageScale - 1) * NAV_SIZE) + 1 + parseInt(pagePerChunk/PAGE_COUNT, 10);
        newPageStart = ((pageScale - 1) * NAV_SIZE) + 1;
      }
    }





    let pageElements = [], needNext, needPrev;
    for(let i=newPageStart; i<=newPageEnd; i++){
      pageElements.push({
        num: i
      });
    }



    if(totalCount > newPageEnd * PAGE_COUNT){
      needNext = true;
    } else {
      needNext = false;
    }

    if(newPageStart >  NAV_SIZE){
      needPrev = true;
    } else {
      needPrev = false;
    }

    this.setState({
      pageElements, needPrev, needNext
    })

  }

  render(){
    const {activePage, handlePageChange} = this.props;
    const {pageElements, needPrev, needNext} = this.state;
    return <PageContainer 
            pageElements={pageElements}
            needPrev={needPrev}
            needNext={needNext}
            activePage={activePage}
            handlePrev={this.handlePrev.bind(this)}
            handleNext={this.handleNext.bind(this)}
            handlePageChange={handlePageChange}
          />
  }


}

export default Pagination;


// WEBPACK FOOTER //
// ./src/components/pagination/index.js